:host([has-bg])::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  pointer-events: none;
  z-index: 2;
}

.profile-container {
  position: relative;
  z-index: 3;
}

.profile {
  margin-bottom: var(--margin-xl);
}
.logo {
  display: block;
  margin: 0 auto var(--margin-xl);
  overflow: hidden;
}
.avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-xxl);
  font-weight: var(--font-weight-medium);
  margin: 0 auto var(--margin-xl);
  overflow: hidden;
}
.logo--circle {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  object-fit: cover;
}
.logo--square {
  width: 96px;
  height: 96px;
  border-radius: 8px;
  object-fit: cover;
}
.logo--rectangle {
  width: 360px;
  height: 120px;
  border-radius: 8px;
  object-fit: contain;
}
.title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  margin: 0 0 var(--margin);
}
.bio {
  font-size: var(--font-size);
  opacity: 0.8;
  margin: 0;
  line-height: 1.5;
  white-space: pre-wrap;
}
.links {
  list-style: none;
  padding: 0;
  margin: 0;
}
.link-item {
  margin-bottom: var(--margin-xl);
}
.link {
  display: block;
  padding: var(--padding-xl) var(--margin-xl);
  text-decoration: none;
  border-radius: var(--border-radius);
  font-weight: var(--font-weight-medium);
  transition:
    transform 0.2s,
    box-shadow 0.2s;
}
.link:hover {
  transform: translateY(-2px);
  box-shadow: var(--box-shadow);
}
.error {
  text-align: center;
  padding: var(--margin-xl);
}
.error h1 {
  font-size: var(--font-size-xxl);
  margin-bottom: var(--margin);
}
.error p {
  color: var(--color-text-secondary);
}
.branding {
  margin-top: var(--margin-xl);
  font-size: var(--font-size-s);
  opacity: 0.5;
}
.branding a {
  color: inherit;
  text-decoration: none;
}
.branding a:hover {
  text-decoration: underline;
}

.featured-block {
  display: flex;
  flex-direction: column;
  gap: var(--margin-l);
  padding: var(--padding-xl);
  background: color-mix(in srgb, var(--page-text) 15%, var(--page-bg));
  border-radius: var(--border-radius);
  margin-bottom: var(--margin-xl);
  text-align: left;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
  border: 1px solid color-mix(in srgb, var(--page-text) 20%, var(--page-bg));
}
:host([has-bg]) .featured-block {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}
a.featured-block {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: opacity 0.2s;
}
a.featured-block:hover {
  opacity: 0.85;
}

.featured-content {
  display: flex;
  flex-direction: column;
  gap: var(--margin-m);
}

.featured-title {
  font-size: var(--font-size-l);
  font-weight: var(--font-weight-bold);
  margin: 0;
}

.featured-description {
  font-size: var(--font-size);
  line-height: 1.6;
  margin: 0;
  opacity: 0.9;
  white-space: pre-wrap;
}

.featured-image {
  width: 100%;
  border-radius: var(--border-radius);
  overflow: hidden;
}

.featured-image img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  max-height: 300px;
}

@media (min-width: 769px) {
  .featured-block {
    flex-direction: row;
    align-items: center;
  }

  .featured-content {
    flex: 1;
  }

  .featured-image {
    flex: 0 0 40%;
    max-width: 250px;
  }

  .featured-image img {
    max-height: 200px;
  }
}

.disclaimer {
  margin-bottom: var(--margin-xl);
  text-align: center;
}

.disclaimer-toggle {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: inherit;
  font-size: var(--font-size-s);
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.disclaimer-toggle:hover {
  opacity: 0.75;
}

.disclaimer-content {
  margin-top: var(--margin);
  text-align: left;
  font-size: var(--font-size-s);
  line-height: 1.7;
}

.disclaimer-text {
  white-space: pre-wrap;
  margin: 0;
}

@media (max-width: 768px) {
  .logo--circle,
  .logo--square {
    width: 80px;
    height: 80px;
  }

  .logo--rectangle {
    width: 240px;
    height: 80px;
  }

  .avatar {
    font-size: var(--font-size-xl);
  }

  .title {
    font-size: var(--font-size-l);
  }

  .bio {
    font-size: var(--font-size-s);
  }

  .link {
    padding: var(--padding-xl) var(--padding-l);
    font-size: var(--font-size);
  }
}
